
import { FC, ReactNode, useCallback, useMemo } from 'react';
import { useResizedImage } from '@brg/ui';
import { TagImgWrapper } from './styles';
import { Endpoints } from '@brg/api';
import ExploreHseContextsExternal from 'shared/pages/exploreHseContextsNew/exploreHseContextsExternal';
import { executeTypograf } from 'shared/utils/executeTypograf';
import { convertPxToMm } from 'shared/helpers/utils/measureUnits';
import { isServer } from 'shared/constants/isServer';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const CardComponent = isServer ? {} : require('adaptive-cards');

export const ContextViewWithCard: FC<{
    tag?: any;
    title: ReactNode;
    description?: string;
    card?: any;
    tabs?: ReactNode;
    filters?: ReactNode;
    isLoading?: boolean;
}> = ({
    tag,
    title,
    description,
    tag: card,
    isLoading
}) => {
        const [img, containerRef] = useResizedImage(card?.images);

        const getEmblemComponent = useCallback(({ height, width }) => {

            const dw = convertPxToMm(width);
            const dh = convertPxToMm(height);

            return (
                <TagImgWrapper width={width} height={height}>
                    <CardComponent.MasterCard
                        data={{
                            images: tag?.images,
                            number: '№ Ае',
                        }}
                        image={Endpoints.files + '/' + img?.url}
                        templateType={'WarholCardA4'}
                        appName={'gallllery'}
                        contextName={'zeland'}
                        typeCard={''}
                        dw={dw}
                        dh={dh}
                    />
                </TagImgWrapper>
            )
        }, [img])

        const teamProps = useMemo(() => ({
            contextName: tag?.tagId,
            name: title,
            about: executeTypograf(description || ''),
            onlyMainDescription: true,
            isShowFullDescription: true,
            titleImages: tag?.images,
            isShowTeamEmblem: true,
            getEmblemComponent,
            mainFilter: {
                requiredTagIds: [tag?.tagId],
            }
        }), [title, description, tag, getEmblemComponent])

        return <ExploreHseContextsExternal context="creativecityacademy" overrideTeamProps={teamProps} />
    }
import { FC, ReactNode, useCallback, useMemo } from 'react';
import { useResizedImage } from '@brg/ui';
import { TagImgWrapper } from './styles';
import { Endpoints } from '@brg/api';
import ExploreHseContextsExternal from 'shared/pages/exploreHseContextsNew/exploreHseContextsExternal';
import { executeTypograf } from 'shared/utils/executeTypograf';
import { convertPxToMm } from 'shared/helpers/utils/measureUnits';
import { isServer } from 'shared/constants/isServer';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const CardComponent = isServer ? {} : require('adaptive-cards');

export const ContextViewWithCard: FC<{
    tag?: any;
    title: ReactNode;
    description?: string;
    card?: any;
    tabs?: ReactNode;
    filters?: ReactNode;
    isLoading?: boolean;
}> = ({
    tag,
    title,
    description,
    tag: card,
    isLoading
}) => {
        const [img, containerRef] = useResizedImage(card?.images);

        const getEmblemComponent = useCallback(({ height, width }) => {

            const dw = convertPxToMm(width);
            const dh = convertPxToMm(height);

            return (
                <TagImgWrapper width={width} height={height}>
                    <CardComponent.MasterCard
                        data={{
                            images: tag?.images,
                            number: '№ Ае',
                        }}
                        image={Endpoints.files + '/' + img?.url}
                        templateType={'WarholCardA4'}
                        appName={'gallllery'}
                        contextName={'zeland'}
                        typeCard={''}
                        dw={dw}
                        dh={dh}
                    />
                </TagImgWrapper>
            )
        }, [img])

        const teamProps = useMemo(() => ({
            contextName: tag?.tagId,
            name: title,
            about: executeTypograf(description || ''),
            onlyMainDescription: true,
            isShowFullDescription: true,
            titleImages: tag?.images,
            isShowTeamEmblem: true,
            getEmblemComponent,
            mainFilter: {
                requiredTagIds: [tag?.tagId],
            }
        }), [title, description, tag, getEmblemComponent])

        return <ExploreHseContextsExternal context="creativecityacademy" overrideTeamProps={teamProps} />
    }